import api from '../axios'


export default {
  login: (payload) => api.post('supplier/login', payload),
  // logout: () => api.get('/staff/logout'),
  getCurrentUser: () => api.get('/supplier/get-current'),
  getPermissions: () => api.get('/supplier/get-current-permissions'),
  verify2FA: (payload, user_id) => api.put(`/supplier/2fa/${user_id}/validate-2fa`, payload),
}
